module.exports = __webpack_public_path__ + "img/expand-icon.a46122e7.svg";